import React, { useState, useEffect } from 'react';

import useProfile from 'b2b-ui-components-lib/lib/hooks/useProfile';
import { setInSessionStorage, isDevEnv, isAuthForDev, setAuthTokens, setAxiosInstanceBaseUrl } from 'common/utils/app.utils';
import { MODULE_ID, PROFILE_DATA } from 'home/common/constants/constants';
import { getAccessTokenForDev } from 'home/view/manage-feasibility/services';
import { showServiceError } from 'common/utils/app.utils';
import appConfig from 'config/config';

const useJourneySelector = () => {
  const { fetchProfile } = useProfile();

  const [userProfileLoading, setUserProfileLoading] = useState(true);
  const [isAuthJourney, setIsAuthJourney] = useState(false);

  const fetchUserProfile = async () => {
    setUserProfileLoading(true);
    try {
      const accessToken = localStorage?.getItem('accessToken');

      if (!accessToken) {
        setUserProfileLoading(false);
        setIsAuthJourney(false);
        throw new Error('accessToken missing; Unauth user');
      }

      const res = await fetchProfile();

      if (res) {
        setInSessionStorage(MODULE_ID, PROFILE_DATA, res);
        setUserProfileLoading(false);
        setIsAuthJourney(true);
      }
    } catch (e) {
      setUserProfileLoading(false);
      setIsAuthJourney(false);
      // console.error(e);

      // // DEV_ENV: exceptional handling if setTimeout on line:54 works before localStorage.setItem on line:53
      // if (isDevEnv()) {
      //   if (isAuthForDev()) {
      //     fetchUserProfile();
      //   }
      // }
    }
  };

  const handleSetTokenDev = async (cb) => {
    setUserProfileLoading(true);
    try {
      const { res, err } = await getAccessTokenForDev();
      if (res) {
        const { data: { accessToken, refreshToken } = {} } = res;
        if (res?.data) {
          setAuthTokens({ accessToken, refreshToken });
          setTimeout(cb, 1000);
          setAxiosInstanceBaseUrl(appConfig.apiBaseUrl);
        }
      } else if (err) {
        const errorMsg = err?.response?.data?.errorMsg;
        setUserProfileLoading(false);
        showServiceError({ show: true, data: 'ATB Loggin issue. Check console error for more information.', redirect: false });
        throw new Error(errorMsg);
      }
    } catch (e) {
      setUserProfileLoading(false);
      console.error(e);
    }
  };

  const handleUnsetTokenDev = () => {
    setAuthTokens({ accessToken: null, refreshToken: null });
    setUserProfileLoading(false);
    setIsAuthJourney(false);
  };

  useEffect(() => {
    if (isDevEnv()) {
      if (isAuthForDev()) {
        handleSetTokenDev(fetchUserProfile);
      } else {
        handleUnsetTokenDev();
      }
    } else {
      fetchUserProfile();
    }
  }, []);

  return [userProfileLoading, isAuthJourney, setIsAuthJourney];
};

export default useJourneySelector;
